import { useAuth0 } from '@auth0/auth0-react';
import AuthService from 'Lib/API/Auth';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { useParams } from 'react-router-dom';
import './bulkTagging.scss';

const BulkTagging = ({
  closeModal,
  initialTags,
  type = "account",
  accountId,
  addTagHandler,
  modelType = true,
  addTagLoading,
  title = "Add Tags"
}) => {
  const [orgTags, setOrgTags] = useState([]);
  const [selectedTag, setSelectedTag] = useState(initialTags || []);
  const [loading, setLoading] = useState(false);
  const [addNewOrgTag, setAddNewOrgTag] = useState(false);
  const [newOrgTag, setNewOrgTag] = useState('');
  const [searchTag, setSearchTag] = useState('');
  const { getAccessTokenSilently } = useAuth0();



  const addTag = async (tagObj) => {
    const tag = tagObj.title;
    setSelectedTag((prev) => [...prev, tag]);
    const updatedTags = orgTags.filter((item) => item.title !== tag);
    setOrgTags(updatedTags);
  };

  const deleteTag = async (tag) => {
    const updatedSelectedTag = selectedTag.filter((item) => item !== tag);
    setSelectedTag(updatedSelectedTag);
    setOrgTags((prev) => [...prev, { title: tag }]);
  };

  const getTags = async () => {
    const token = await getAccessTokenSilently();
    setLoading(true);
    AuthService.getTags(
      type,
      accountId ? accountId : '',
      searchTag,
      token
    )
      .then((res) => {
        const tags = res?.result?.sort((a, b) => (a.title > b.title ? 1 : -1))
        setOrgTags(tags.filter((item) => !selectedTag.find((tag) => tag === item.title)));
        setLoading(false);
      })
      .catch((err) => {
        console.log('err: ', err);
        toastr.error('Error', err?.data?.message || 'Something went wrong');
        setLoading(false);
      });
  };

  const addNewTagHandler = () => {
    if (!newOrgTag) return toastr.info('validation', 'Please enter tag name');
    if (
      orgTags.map((item) => item.title).find((tag) => tag === newOrgTag) ||
      selectedTag.find((tag) => tag === newOrgTag)
    )
      return toastr.info("validation", "Tag already exist");
    createTag();
  };
  const createTag = async () => {
    const token = await getAccessTokenSilently();
    setLoading(true);
    AuthService.createTag(
      { title: newOrgTag, type, },
      token
    )
      .then((res) => {
        setOrgTags([...orgTags, { title: newOrgTag }]);
        setAddNewOrgTag(false);
        setNewOrgTag('');
        getTags();
        toastr.success('Success', 'Tag created successfully');
      })
      .catch((err) => {
        toastr.error('Error', err?.data?.message || 'Something went wrong');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getTags();
  }, [searchTag]);


  const saveHandler = () => {
    if(!selectedTag?.length) return toastr.error('Error', 'Please select tag');
    addTagHandler(selectedTag);
  } 

  return (
    <>
      <div className="AddNewTag_container">
        {modelType && (
          <div
            className="close_tag_modale"
            onClick={() => {
              closeModal();
            }}
          >
          x
          </div>
        )}
        <div className="add_tags_text add__tags-title">{title}</div>
        <div className="search__bar__tag">
          <p style={{ fontSize: '14px', fontWeight: '500' }}>Selected Tags</p>
          <div className="selected_tags">
            {selectedTag?.length > 0
              ? selectedTag
                ?.sort((a, b) =>
                  a?.toLowerCase().localeCompare(b?.toLowerCase())
                )
                ?.map((tag, idx) => (
                  <div className="tag" key={idx}>
                    {tag}
                    <span
                      style={{
                        marginLeft: '5px',
                        cursor: 'pointer',
                        fontSize: '12px',
                      }}
                      onClick={() => deleteTag(tag)}
                    >
                      x
                    </span>
                  </div>
                ))
              : ''}
          </div>
          <div className="search_tag">
            <input
              type="text"
              placeholder="Search Tags"
              className="form-control form-control-lg form-control-solid h-100 search-input mt-3"
              value={searchTag}
              onChange={(e) => setSearchTag(e.target.value)}
            />
          </div>
          <div className="org_tags_container">
            <div className="org_tags">
              {loading ? (
                <div>loading...</div>
              ) : orgTags.length === 0 ? (
                <div className="no_tags">No tags</div>
              ) : (
                orgTags
                  ?.sort((a, b) => (a.title > b.title ? 1 : -1))
                  ?.map((tag, idx) => (
                    <div className="tag" key={idx}>
                      {tag.title}
                      <span
                        style={{
                          marginLeft: '5px',
                          cursor: 'pointer',
                          fontSize: '12px',
                        }}
                        onClick={() => addTag(tag)}
                      >
                        +
                      </span>
                    </div>
                  ))
              )}
            </div>
            {!addNewOrgTag && (
              <div
                className={`add_org_tag mt-2 ${orgTags?.length > 40 ? 'addOrg_disabled' : ''
                  }`}
                onClick={() => setAddNewOrgTag(true)}
              >
                + New Tag
              </div>
            )}
          </div>
          {addNewOrgTag && (
            <>
              <div className="add_new_org_tag">
                <div className="addNewTag">New Tag</div>
                <input
                  type="text"
                  className="form-control form-control-lg form-control-solid h-100 search-input mt-3"
                  placeholder="Tag Name"
                  value={newOrgTag}
                  onChange={(e) => setNewOrgTag(e.target.value)}
                />
              </div>
              <div className="add_orgTag_btn">
                <button
                  className="btn btn-primary"
                  onClick={addNewTagHandler}
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner spinner-white"
                      style={{ width: '20px' }}
                    ></span>
                  ) : (
                    <span style={{ whiteSpace: 'nowrap' }}>Add Tag</span>
                  )}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="bulk_tagging_modal__actions user__header__action">
        <button
          className="cancel_user_btn"
          onClick={closeModal}
        >
          Cancel
        </button>
        <button
          className="save_user_btn btn btn-primary"
          onClick={saveHandler}
        disabled={addTagLoading || !selectedTag?.length}
        >
          <span className="user_btn_text">Add</span>
          {addTagLoading && (
             <span className="ml-3 spinner spinner-white"></span>
           )}
        </button>
      </div>
    </>
  );
};

export default BulkTagging;
